export default __webpack_public_path__ + "static/media/icon_industry_news.c5703950.webp";